<script setup>
  const model = defineModel({ type: Array });

  const directions = [
    { name: 'N', angle: 0 },
    { name: 'NNE', angle: 22.5 },
    { name: 'NE', angle: 45 },
    { name: 'ENE', angle: 67.5 },
    { name: 'E', angle: 90 },
    { name: 'ESE', angle: 112.5 },
    { name: 'SE', angle: 135 },
    { name: 'SSE', angle: 157.5 },
    { name: 'S', angle: 180 },
    { name: 'SSW', angle: 202.5 },
    { name: 'SW', angle: 225 },
    { name: 'WSW', angle: 247.5 },
    { name: 'W', angle: 270 },
    { name: 'WNW', angle: 292.5 },
    { name: 'NW', angle: 315 },
    { name: 'NNW', angle: 337.5 },
  ];

  const cardinalLabels = directions.filter(d =>
    ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'].includes(d.name)
  );

  function labelPos(angle, distance) {
    const rad = angle * Math.PI / 180;
    return {
      left: `calc(50% + ${(Math.sin(rad) * distance).toFixed(2)}%)`,
      top: `calc(50% - ${(Math.cos(rad) * distance).toFixed(2)}%)`,
    };
  }
</script>

<template>
  <div class="jwx-wind-dir">
    <!-- Cardinal labels -->
    <span
      v-for="dir in cardinalLabels"
      :key="'label-' + dir.name"
      class="jwx-wind-dir__label"
      :style="labelPos(dir.angle, 41)"
    >
      {{ dir.name }}
    </span>

    <!-- Compass circle -->
    <div class="jwx-wind-dir__compass">

      <!-- Selected wedge highlights -->
      <div
        v-for="dir in directions"
        :key="'wedge-' + dir.name"
        class="jwx-wind-dir__wedge"
        :class="{ 'is-selected': model.includes(dir.name) }"
        :style="{ '--dir-angle': `${dir.angle}deg` }"
      ></div>

      <!-- Checkbox inputs — each label is a full wedge, rotated into place -->
      <label
        v-for="dir in directions"
        :key="'input-' + dir.name"
        class="jwx-wind-dir__input"
        :style="{ '--dir-angle': `${dir.angle}deg` }"
      >
        <input
          type="checkbox"
          :value="dir.name"
          v-model="model"
          class="jwx-hidden-control"
        />
        <span
          class="jwx-wind-dir__indicator"
          :data-selected="model.includes(dir.name)"
        ></span>
      </label>
    </div>
  </div>
</template>
